import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  public languages = ['es'];

  constructor(public translate: TranslateService, private cookieService: CookieService) {
    let browserLang: any;
    this.translate.addLangs(this.languages);
    if (this.cookieService.check('lang')) {
      browserLang = this.cookieService.get('lang');
    }
    else {
      browserLang = translate.getBrowserLang();
    }
    translate.use(browserLang.match(/es/) ? browserLang : 'es'); // spanish by default
  }

  public setLanguage(lang: string): void {
    this.translate.use(lang);
    this.cookieService.set('lang', lang);
  }

}
